import React from 'react';

import colors from '../../../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function Separator({ color = colors.gray[300], ...props }: Props) {
  return (
    <svg
      width="8"
      height="6"
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.4705 0.219496C2.76349 -0.0733011 3.23836 -0.0731454 3.53116 0.219844L5.52985 2.21984C5.82251 2.5127 5.82251 2.9873 5.52985 3.28016L3.53116 5.28016C3.23836 5.57315 2.76349 5.5733 2.4705 5.2805C2.17751 4.98771 2.17735 4.51283 2.47015 4.21984L3.93903 2.75L2.47015 1.28016C2.17735 0.987167 2.17751 0.512293 2.4705 0.219496Z"
        fill={color}
      />
    </svg>
  );
}
